import type { UserId } from 'core/types';
import type { OrganizationUserRoles } from 'core/base';

export class UserModel {
  id: UserId;

  email: string;

  roles: OrganizationUserRoles[] | null;

  firstName?: string;

  lastName?: string;

  uniqueUserName?: string;

  userName?: string;
}
